/* lua.js generated code 0.3.0 */

var NameCardButton = xClass("NameCardButton", function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/homeScene_info_btn.csb")
})
NameCardButton.prototype.ctor = function () {
    let self = this;
    self.init()
}
NameCardButton.prototype.init = function () {
    var self = this
    var label = self.getChildByName("txt")
    label.getVirtualRenderer().setAdditionalKerning(-2)
    var size = label.getVirtualRendererSize()
    label.setAnchorPoint(cc.p(0.5, 0.5))
    label.setPosition(cc.p(-3, label.getPositionY() - size.height / 2 + 25))

    let newText = cc.LabelTTF.create('个人信息', FONT_DEF.sidebox)
    newText.x = -1
    newText.y = -47
    label.removeFromParent(true)
    self.addChild(newText, 2, "txt")

    let oldBtn = self.getChildByName("bg")
    let pos = oldBtn.getPosition()
    oldBtn.setPosition(pos.x - 10, pos.y - 10)
    var btn = UIButton.create(oldBtn, true)
    btn.on(UIButtonEvent.Click, handler(self, self.onOpenNameCard))
    self.btn = btn

    let prompt = cc.Sprite.createWithSpriteFrameName("uilibrary/btn_prompt.png")
    prompt.setAnchorPoint(0.5, 0.5)
    prompt.setPosition(30, 30)
    prompt.scale = 0.8
    self.addChild(prompt, 10)
    self.prompt = prompt
    self.prompt.setVisible(false)
    self.updateDot()
}
NameCardButton.prototype.onOpenNameCard = function () {
    var self = this
    UserManager.getInstance().openNameCradPanel(UserManager.getInstance().uid, {
        type: "main",
    });
}


NameCardButton.prototype.updateDot = function () {
    let self = this
    self.prompt.setVisible( DressManager.getInstance().getNewDressTipList().length > 0)
}
module.exports = NameCardButton
